import { Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumns } from './hooks/useColumns';
import { StudentsRemovalRequestHistory } from '../types/history';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import { useStudentsRemovalRequestHistoryList } from './StudentsRemovalRequestHistoryListLoader';

export interface StudentsRemovalRequestHistoryTableProps {
  data: StudentsRemovalRequestHistory[];
  loading: boolean;
}

export function StudentsRemovalRequestHistoryTable({
  data,
  loading,
}: StudentsRemovalRequestHistoryTableProps) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_HISTORY,
  );

  const { query } = useStudentsRemovalRequestHistoryList();

  const texts = useMemo(() => {
    return t<
      string,
      {
        empty: {
          noResults: {
            title: string;
            body: string;
          };
          noSearch: {
            title: string;
            body: string;
          };
        };
      }
    >('history.table', {
      returnObjects: true,
    });
  }, [t]);

  const textsEmpty = useMemo(() => {
    if (!query.studentNameOrId) {
      return texts.empty.noSearch;
    }
    return texts.empty.noResults;
  }, [texts, query]);

  const columns = useColumns();

  return (
    <Table
      columns={columns}
      data={data}
      isLoadingResults={loading}
      noResultsText={
        <TableEmptyContent
          title={textsEmpty.title}
          subtitle={textsEmpty.body}
        />
      }
    />
  );
}
